import { IconDefinition } from "./types";

const calendarDay: IconDefinition = {
  iconName: "calendar-day",
  width: 448,
  height: 512,
  svgPathData:
    "M144 0l0 64 160 0 0-64 48 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 48 0zm0 112l-96 0 0 320 352 0 0-320-256 0zm0 144l0 80 80 0 0-80-80 0zM96 208l176 0 0 176-176 0 0-176z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "calendar-day",
  unicode: 0xf783,
};

export { calendarDay };
